import Vue from 'vue';

/**
 * This renders two children, the original row (just like Row.vue) and a row
 * containing the expanded content.
 * Any listeners are passed on to the expanded row. The original row receives a
 * new onClick listener to toggle the expanded row's visibility.
 */
export default Vue.extend({
  functional: true,
  props: {
    expanded: Boolean,
  },
  render(createElement, context) {
    const mainRow = createElement(
      'tr',
      {
        class: 'table-row expandable',
        on: {
          click(event: PointerEvent) {
            if (event.currentTarget) {
              (event.currentTarget as HTMLElement).classList.toggle('expanded');
            }
          },
        },
      },
      context.scopedSlots.default({}),
    );
    const expandedRow = createElement(
      'tr',
      {
        class: 'table-row expanded-row',
        on: context.listeners,
      },
      context.scopedSlots.expandedRow({}),
    );
    return [ mainRow, expandedRow ];
  },
});
